import { useState, useEffect, useRef } from 'react';
import { Card } from '../../../components/Card';

export default function PersonalNumberCard({
  title,
  value,
  additionalText = '',
  duration = 1500,
}) {
  const [displayValue, setDisplayValue] = useState(0);
  const animationRef = useRef(null);
  const cardRef = useRef(null);
  const targetValue = value !== null && value !== undefined ? value : 0;

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          startCountAnimation();
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.1 }
    );

    if (cardRef.current) {
      observer.observe(cardRef.current);
    }

    return () => {
      if (animationRef.current) {
        cancelAnimationFrame(animationRef.current);
      }
      if (cardRef.current) {
        observer.unobserve(cardRef.current);
      }
    };
  }, [targetValue]);

  const startCountAnimation = () => {
    const startTime = performance.now();
    const startValue = 0;
    const endValue = targetValue;

    const animate = (currentTime) => {
      const elapsedTime = currentTime - startTime;
      const progress = Math.min(elapsedTime / duration, 1);
      const easedProgress = easeOutQuad(progress);
      const currentValue = startValue + (endValue - startValue) * easedProgress;

      setDisplayValue(Math.floor(currentValue));

      if (progress < 1) {
        animationRef.current = requestAnimationFrame(animate);
      } else {
        setDisplayValue(endValue);
      }
    };

    animationRef.current = requestAnimationFrame(animate);
  };

  const easeOutQuad = (t) => t * (2 - t);

  const formatNumber = (num) => {
    if (num === null || num === undefined) return '0';
    const number = Number(num);
    return number % 1 === 0
      ? number.toString()
      : number.toFixed(2).replace(/\.?0+$/, '');
  };

  return (
    <div className="col-sm-12 col-md-4 mb-3" ref={cardRef}>
      <Card>
        <div className="d-flex justify-content-center">
          <span style={{ textAlign: 'center' }}>
            <p className="fw-semibold m-0">{title}</p>
            <p className="fw-semibold fs-4 m-0">{formatNumber(displayValue)}</p>
            {additionalText && <span className="ms-2">{additionalText}</span>}
          </span>
        </div>
      </Card>
    </div>
  );
}
